import { Component, ErrorInfo, ReactNode } from 'react';  

// Define TypeScript Props and State interfaces  
interface ErrorBoundaryProps {  
  children: ReactNode; // Expect children to be of type ReactNode  
}  

interface ErrorBoundaryState {  
  hasError: boolean, // State to check if an error has occurred  
  error: any
}  

// Create the ErrorBoundary component  
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {  
  constructor(props: ErrorBoundaryProps) {  
    super(props);  
    this.state = { hasError: false, error:'' }; // Initialize the hasError state to false  
  }  

  // Lifecycle method to catch errors in child components  
  static getDerivedStateFromError(error: Error) {  
    // Update state so the next render will show the fallback UI  
    return { hasError: true, error:error };  
  }  

  // Lifecycle method to log error information (optional)  
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {  
    // You can also log the error to an error reporting service  
    console.error("ErrorBoundary caught an error:", error, errorInfo);  
  }  

  // Render fallback UI if there's an error, otherwise render children  
  render() {  
    if (this.state.hasError) {  
      return <h1>Something went wrong.</h1>; // Fallback UI  
    }  

    return this.props.children; // Render children if no error  
  }  
}  

export default ErrorBoundary;  